import axios from "axios";
import { triggerSessionAlert } from "../utils/SessionAlertHelper";

// Base URL for your API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Add new brand
export const addBrand = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/brands/add`, formData, {
      withCredentials: true,
    });

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.brands,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching orders.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

//Get all brand data
export const getAllBrandData = async (params = {}) => {
  try {
    const { searchTerm = "", page = 1, limit = 10 } = params;
    const response = await axios.get(
      `${API_BASE_URL}/brands?&page=${page}&limit=${limit}&search=${searchTerm}`,
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.brands,
      totalPages: response.data.data.totalPages,
      currentPage: response.data.data.currentPage,
      totalCount: response.data.data.totalBrands,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching orders.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const updateBrand = async (formData) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/brands/update`,
      formData,
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.brands,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating the brand.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

// Change brand status
export const updateBrandStatus = async (brandId, newStatus) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/brands/update/status`,
      { brandId, status: newStatus },
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message,
      data: response.data.data.brands,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating the brand status.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const getBrandNamesList = async (page = 1, limit = 10,category="") => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/products/brands?page=${page}&limit=${limit}&category=${category}`,
      { withCredentials: true }
    );
    const data = response.data.data; 
    const brands = (data.brands || []).map((brand) => ({
      ...brand,
      id: brand._id || brand.id,
      name: brand.name
    }));
    return {
      brands,
      totalPages: data.totalPages || 1
    };
  } catch (error) {
        if (error.response?.status >= 500) {
      window.location.href = "/server-down";
    return { brands: [], totalPages: 1 };
    }
    console.error("Error fetching product IDs:", error);
    return { brands: [], totalPages: 1 };
  }
}
